module.exports = __webpack_public_path__ + "static/media/wasserleitung_detail_tn.7aa4d131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/wasserleitung_detail_tn.jpg
// module id = 780
// module chunks = 0